module.exports = __webpack_public_path__ + "img/team_pic2.16f26155.jpg";